import { signal } from '@angular/core';
import { TCatalogOption } from '../model';

export const beneficiaryYesNo$$ = signal<TCatalogOption[]>([
  { key: 'כן', value: 3 }, // is single beneficiary = 2
  { key: 'לא', value: 2 }
]);
